import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HeaderLinkBlockConfig } from '@front-platform/content-builder';
import { headerLinkBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface HeaderLinkBlockRuntimeConfig {}

export type HeaderLinkBlockConfigInput = Partial<
  Omit<HeaderLinkBlockConfig, keyof HeaderLinkBlockRuntimeConfig> & HeaderLinkBlockRuntimeConfig
>;
export type HeaderLinkBlockResolvedConfig = Omit<
  HeaderLinkBlockConfig,
  keyof HeaderLinkBlockRuntimeConfig
> &
  Partial<HeaderLinkBlockRuntimeConfig>;
export interface HeaderLinkBlockContract extends ConfigComponentContract<
  HeaderLinkBlockConfigInput,
  HeaderLinkBlockResolvedConfig
> {}

@Component({
  selector: 'app-header-link-block',
  templateUrl: './header-link-block.component.html',
  standalone: false,
})
export class HeaderLinkBlockComponent implements HeaderLinkBlockContract {
  readonly config = input<HeaderLinkBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    HeaderLinkBlockConfig,
    HeaderLinkBlockRuntimeConfig
  >(headerLinkBlockResolveConfig, () => ({ config: this.config() }));
  get label(): string | undefined {
    return this.resolvedConfig()['label'] as unknown as string | undefined;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HeaderLinkBlockComponent, { 'keyAliases': {} });
